const Footer = () => {
	return (
		<footer className="bg-gray-100 py-12 text-gray-600">
			<p className="text-sm text-center">©2021 ifuelsmart. All rights reserved.</p>
		</footer>
	);
};

export default Footer;
